(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/init-momang/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/casino-react/init-momang/assets/javascripts/init.js');
"use strict";


const {
  render
} = ReactDOM;
const {
  useEffect
} = React;
const RouterRoot = svs.components.casino_react.root.Root;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const App = () => {
  useEffect(() => {
    svs.components.casino.animateHeader.init();
  }, []);
  return React.createElement(React.StrictMode, null, React.createElement(ErrorBoundary, null, React.createElement(RouterRoot, null)));
};
const init = appRoot => {
  if (appRoot) {
    render(React.createElement(App, null), appRoot);
  }
};
const appRoot = document.getElementById('casino-search');
init(appRoot);
setGlobal('svs.components.casino_react.initMomang', {
  init,
  App
});

 })(window);